"use strict";
// eslint-disable-next-line import/no-extraneous-dependencies
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSportGamesData = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const lang_1 = require("../../../utils/lang");
const logger_1 = require("../../../utils/logger");
const selectors_1 = require("../../AccountProvider/selectors");
const selectors_2 = require("../../ConfigProvider/selectors");
const useIntegrationData_1 = require("./useIntegrationData");
const useSportGamesData = () => {
    (0, logger_1.logger)('useSportGamesData');
    const { loaded, token, error, refreshToken, resetToken } = (0, useIntegrationData_1.useIntegrationData)({
        gameVendor: betweb_openapi_axios_1.VirtualGameVendor.SportGames,
    });
    const langName = (0, lang_1.getCurrentLng)();
    const { id: userId } = (0, react_redux_1.useSelector)(selectors_1.selectAccountUser) || {};
    const config = (0, react_redux_1.useSelector)(selectors_2.selectConfig);
    const tokenParam = userId && token ? `&sessionToken=${token}` : '';
    const src = `${config.SPORTGAMES_PROVIDER_BASE_URL}?cid=astrabetcom&productId=sport-games-lobby${tokenParam}&lang=${langName}`;
    return (0, react_1.useMemo)(() => ({
        loaded,
        error,
        src,
        refreshToken,
        resetToken,
    }), [error, loaded, src, refreshToken, resetToken]);
};
exports.useSportGamesData = useSportGamesData;
//# sourceMappingURL=useSportGamesData.js.map